/*
  Cart drawer additions:

    <item name>                          750 kr
    ...
    DELIVERY          1-3 BUSINESS DAYS (ESTIMATED)
    SHIPPING          FREE  /  CALCULATED AT CHECKOUT
    Add 1 more for free shipping.
    SUBTOTAL          750 kr

  and relabels Dawn's "Estimated total" to "Subtotal", which is what that figure
  actually is — it excludes shipping.

  NOT ONE ENGLISH WORD IS WRITTEN IN THIS FILE. Text typed into a script is
  invisible to Shopify's translation system, so a Japanese visitor would get
  English no matter how many times Translate & Adapt was re-run. Every string is
  a setting on sections/bb-layout.liquid, printed into <script id="bb-strings">
  and read below. If you need a new word in the cart, add a setting there. Do not
  type it here.

  If the tag is missing or malformed the drawer simply renders without the extra
  rows rather than printing "undefined" at a customer.

  THE DELIVERY ESTIMATE IS ONE ROW FOR THE ORDER, NOT A LINE PER ITEM. It used to
  print under every product name, inside the name cell — which squeezed the title
  column so hard that "REBELLION EARTHTONE HAT" wrapped to "REBELLIO / N EARTHTO
  / NE HAT". It also repeated itself on every line and implied each item ships
  separately. Do not move it back into the line items.

  WHY NO SHIPPING PRICE IS SHOWN: a figure written into the theme is not
  converted by Shopify Markets, so a visitor paying in yen would be quoted a
  Swedish number. "Calculated at checkout" is true in every currency.

  THIS ONLY DISPLAYS THE FREE-SHIPPING RULE — IT DOES NOT ENFORCE IT. That is the
  automatic "Free shipping on 2 or more items" discount in the Shopify admin.
  FREE_SHIPPING_AT below must match its minimum quantity.

  Loaded from snippets/grainy-wall.liquid. Styling: assets/bb-cart-sheet.css.
*/
(function () {
  var FREE_SHIPPING_AT = 2;

  var S = {};
  var tag = document.getElementById('bb-strings');
  if (tag) {
    try { S = JSON.parse(tag.textContent) || {}; } catch (e) { S = {}; }
  }

  /* No strings, nothing to say. Better a plain drawer than English in Osaka. */
  var READY = !!(S.shipping && S.subtotal);

  var observer = null;
  var scheduled = false;

  function itemCount(root) {
    var inputs = root.querySelectorAll('.quantity__input, input[type="number"]');
    var total = 0;
    Array.prototype.forEach.call(inputs, function (input) {
      var n = parseInt(input.value, 10);
      if (!isNaN(n)) total += n;
    });
    return total;
  }

  function row(label, value) {
    var el = document.createElement('div');
    el.className = 'bb-cart-line';
    el.setAttribute('data-bb-cart', '');
    var l = document.createElement('span');
    l.textContent = label;
    var v = document.createElement('span');
    v.className = 'bb-cart-line__value';
    v.textContent = value;
    el.appendChild(l);
    el.appendChild(v);
    return el;
  }

  function render() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;

    Array.prototype.forEach.call(
      drawer.querySelectorAll('[data-bb-cart]'),
      function (el) { if (el.parentNode) el.parentNode.removeChild(el); }
    );

    if (!READY) return;

    var footer = drawer.querySelector('.drawer__footer');
    if (!footer) return;
    var totals = footer.querySelector('.totals');
    if (!totals) return;

    var count = itemCount(drawer);
    if (count === 0) return;

    /* Delivery first, then Shipping: when it arrives, then what it costs. */
    if (S.eta) {
      var when = S.estimated ? S.eta + ' ' + S.estimated : S.eta;
      totals.parentNode.insertBefore(row(S.delivery || '', when), totals);
    }

    var isFree = count >= FREE_SHIPPING_AT;
    var shipping = row(S.shipping, isFree ? S.free : S.atCheckout);
    totals.parentNode.insertBefore(shipping, totals);

    if (!isFree && S.nudge) {
      var nudge = document.createElement('p');
      nudge.className = 'bb-cart-nudge';
      nudge.setAttribute('data-bb-cart', '');
      nudge.textContent = S.nudge.replace('[count]', String(FREE_SHIPPING_AT - count));
      shipping.parentNode.insertBefore(nudge, shipping.nextSibling);
    }

    var label = footer.querySelector('.totals__subtotal');
    if (label && label.textContent.trim() !== S.subtotal) label.textContent = S.subtotal;

    var tax = footer.querySelector('.tax-note');
    if (tax && S.taxes && tax.textContent.trim() !== S.taxes) tax.textContent = S.taxes;
  }

  /* Dawn replaces the drawer's markup wholesale on every cart change, so this
     has to re-run afterwards. The observer is disconnected around the write,
     otherwise our own insertions would retrigger it forever. */
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      if (observer) observer.disconnect();
      render();
      watch();
    });
  }

  function watch() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    if (!observer) observer = new MutationObserver(schedule);
    observer.observe(drawer, { childList: true, subtree: true });
  }

  function start() { render(); watch(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
